// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7665":"71f670ec","9282":"dfa5131b"}[chunkId] + ".chunk.css";
};